import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, Output, ViewChild } from '@angular/core';
import { InspectionImageDto, LocationOption } from 'remarketing-angular-library';
import {
  ActionBarBtnConfig, ActionBarComponent,
  ModalComponent,
  SpinnerComponent, TrapFocusComponent
} from 'remarketing-ui-components-lib';
import { PostingAnalyticsHelperService } from '../../services/posting-analytics-helper.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-photos-card',
    templateUrl: './photos-card.component.html',
    styleUrls: ['./photos-card.component.scss'],
    imports: [TranslocoDirective, SpinnerComponent, ActionBarComponent, TrapFocusComponent, ModalComponent, CommonModule],
    schemas: [NO_ERRORS_SCHEMA]
})
export class PhotosCardComponent {
  @ViewChild(ModalComponent) deletePhotosModal: ModalComponent;
  pluralizedPhotoText = 'photo';
  selectedCardCount = 0;
  //this properties are mandatory
  //Incoming photos array
  @Input() photoList: InspectionImageDto[];
  //Need flow name to customize image ids if multiple photoscard comp is used in one parent component
  @Input() flowName = 'photo';
  //index of the current iteration
  @Input() currIndex: number;
  //any button selection from action bar will trigger this event emitter
  @Output() photosCardDeletionStatus = new EventEmitter();

  //this properties are optional only needed for photos form component
  @Input() showMainImgTag: boolean;
  @Input() locationOptList: LocationOption[];
  @Output() photosCardLocationOptStatus = new EventEmitter();

  //configuration to action-bar comp
  actionBarConfigArr: ActionBarBtnConfig[] = [
    {
      buttonEventActionName: 'delete',
      buttonInnerTextName: 'Delete 1 Photo',
      buttonClass: 'btn-outline-primary'
    },
    {
      buttonEventActionName: 'cancel',
      buttonInnerTextName: 'Cancel',
      buttonClass: 'btn-link outline-focus ms-2'
    }
  ];

  constructor(private readonly postingAnalyticsHelperService: PostingAnalyticsHelperService) {}

  /**
   *
   * @param event - checkbox event to select the card
   * @param currentItem - current selected item
   * This will select and highlightes the card and will send info to action-bar comp
   */
  onPhotosCardCheckboxChange(event, currentItem) {
    if (event.target.checked) {
      currentItem.isSelected = true;
    } else {
      delete currentItem.isSelected;
    }
    const selectedCards = this.photoList.filter((item: any) => {
      return item.isSelected;
    });
    this.selectedCardCount = selectedCards.length;
    this.setDeleteCountText();
  }

  //construct the delete count text
  setDeleteCountText() {
    if (this.selectedCardCount) {
      this.pluralizedPhotoText = `Photo${this.selectedCardCount > 1 ? 's' : ''}`;
      this.actionBarConfigArr.forEach(item => {
        if (item.buttonEventActionName === 'delete') {
          item.buttonInnerTextName = `Delete ${this.selectedCardCount} ${this.pluralizedPhotoText}`;
        }
      });
    }
  }

  /**
   *
   * @param locListIndex - selected location option index
   * @param selectedOpt - selected location option code
   */
  public setPhotoLocationOpt(locListIndex, selectedOpt) {
    this.photosCardLocationOptStatus.emit({ locListIndex, selectedOpt });
  }

  /**
   *
   * @param actionName - incoming action from action-bar comp
   * process the image list according to incoming action
   */
  updatesFromActionBar(actionName: string) {
    if (actionName === 'delete') {
      this.deletePhotosModal.show();
      this.postingAnalyticsHelperService.trackModalView('deletePhotos');
    } else {
      this.closeModalAndEmitAction(actionName);
    }
  }

  //close the modal and emit the delete modal action
  closeModalAndEmitAction(actionName: string) {
    this.selectedCardCount = 0;
    this.photosCardDeletionStatus.emit({ actionName, currIndex: this.currIndex });
    this.deletePhotosModal.close();
  }
}
